import React from 'react';
import { BoxSection } from './style';

interface Props {
    children: JSX.Element[] | JSX.Element;
    customClass?: string;
}

const ContentWrapper: React.FC<Props> = ({ children, customClass }) => {
    return <BoxSection className={customClass}>{children}</BoxSection>;
};

ContentWrapper.defaultProps = {
    customClass: '',
};

export default ContentWrapper;
